import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ChaveValorStrInterface } from '../../util/chave-valor-str-interface';
import { Util } from '../../util/util';
import { Procedimento } from '../procedimento';
import { ProcedimentoService } from '../procedimento.service';

@Component({
  selector: 'app-procedimento-maintenance',
  templateUrl: './procedimento-maintenance.component.html',
  styleUrls: ['./procedimento-maintenance.component.css']
})
export class ProcedimentoMaintenanceComponent implements OnInit {

  id: number;

  isUpdate: string;

  isInfo: boolean = false;

  desabilitarCadastroDeConflito = true;

  procedimento: Procedimento;

  formularioProcedimento: FormGroup;

  tituloCrud: string = '';

  public listaTipoAgendamento: ChaveValorStrInterface[] = Util.listaTipoAgendamento;

  numeroDaLinhaSelecionadaNaTabelaDeConflito: number = -1;

  onClickNaTabelaDeConflito: any;

  constructor(private procedimentoService: ProcedimentoService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef) {

    this.id = history.state.id;
    this.isUpdate = history.state.isUpdate;

    this.procedimento = new Procedimento();

    this.formularioProcedimento = this.formBuilder.group({
      id: -1,
      nome: ['', [Validators.required, Validators.minLength(3)]],
      disponivel: new FormControl(false),
      apelido: ['', [Validators.required, Validators.minLength(3)]],
      tipoAgendamento: ['', Validators.required],
      valor: [0, Validators.required],
      dilataPupila: new FormControl(false),
      procedimentoConsulta: new FormControl(false),
      executaPosDilatacao: new FormControl(false),
      observacao: [''],
      recomendacoes: [''],
      observacaoSelecao: [''],
      conflitosDTO: [],
      agenda: [],
    });

    this.onClickNaTabelaDeConflito = function (index: number) {
      this.numeroDaLinhaSelecionadaNaTabelaDeConflito = index;
    }
  }

  ngOnInit() {

    if (this.id) {
      if (this.isUpdate == 'S') {
        this.tituloCrud = 'Alterar Procedimento';
      } else {
        this.isInfo = true;
        this.tituloCrud = 'Detalhe Procedimento';
      }
    } else {
      this.tituloCrud = 'Criar Procedimento';
    }

    this.configurarForm();
  }

  save() {

    this.procedimento = Object.assign(new Procedimento(), this.formularioProcedimento.value);

    if (this.isNew()) {
      this.procedimentoService
        .criar(this.procedimento).subscribe(data => {
          // console.log(data)

          this.gotoList();
        }, error => {
          console.log(error);
        });
    } else {
      this.procedimentoService.atualizar(this.procedimento, this.id)
        .subscribe(data => {
          // console.log(data); 

          this.gotoList();
        }, error => {
          console.log(error);
        });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/procedimentos']);
  }

  isNew(): boolean {
    return this.id == null || this.id == 0;
  }

  get formControl() {
    return this.formularioProcedimento.controls;
  }

  configurarForm(): void {

    if (history.state.procedimento) {

      this.procedimento = Object.assign(new Procedimento(), history.state.procedimento);

      this.id = this.procedimento.id;

      this.configurarProcedimento();

    } else if (!this.isNew()) {
      this.procedimentoService.procurarPorId(this.id)
        .subscribe(data => {
          // console.log(data)

          this.procedimento = Object.assign(new Procedimento(), data);

          this.configurarProcedimento();

        }, error => {
          console.log(error);
        });
    }

    // Verifica se e para desabilitar o cadastro de conflito
    this.desabilitarCadastroDeConflito = this.isInfo || !this.id;
  }

  configurarProcedimento(): void {

    this.formularioProcedimento.patchValue(this.procedimento);

    let currentTipoAgendamento = this.listaTipoAgendamento.filter(tipoAgendamento => tipoAgendamento.codigo == this.procedimento.tipoAgendamento)[0];
    this.formularioProcedimento.controls.tipoAgendamento.patchValue(currentTipoAgendamento.codigo);

    if (!this.procedimento.conflitosDTO || this.procedimento.conflitosDTO.length === 0) {
      this.procedimentoService.listarConflitosPeloProcedimentoPrincipalComProjecao(this.id)
        .subscribe(data => {

          this.procedimento.conflitosDTO = data;
          this.formularioProcedimento.controls.conflitosDTO.patchValue(this.procedimento.conflitosDTO);

        });
    }

    this.cd.detectChanges();

    if (this.isUpdate == 'N') {
      this.formularioProcedimento.disable();
    }

  }

  removerConflitoSelecionado(): void {
    if (this.numeroDaLinhaSelecionadaNaTabelaDeConflito != -1 && this.procedimento &&
      this.procedimento.conflitosDTO) {
      this.procedimento.conflitosDTO.splice(this.numeroDaLinhaSelecionadaNaTabelaDeConflito, 1)
    }
  }

  atualizarAtributosDoFormNaEntidadeConflito(): void {
    this.procedimento = this.formularioProcedimento.value;
  }

  navegarParaTelaDeCadastroDeConflito(): void {

    this.atualizarAtributosDoFormNaEntidadeConflito();

    this.router.navigate(['/cadastrarConflito'], {
      state: {
        id: this.id,
        isUpdate: this.isUpdate,
        procedimento: this.procedimento,
      }
    });
  }

  voltarPaginaAnterior(): void {
    this.router.navigate(['procedimentos']);
  }
}
